import isGHMC, {
  formattedDate,
  formattedDateTypeTwo,
  getCurrentDate,
  getFirstDateOfMonth,
  getCurrentDateTime,
  formatDateTimeWithoutSec,
} from "../../../../Common/helper/helpar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import frequencyBinsGVPStore from "./store/frequencyBinsGVPStore";
import { useEffect, useState } from "react";
import { bouncy } from "ldrs";
import { FrequencyBinsInnerExport } from "./FrequencyBinsInnerExport";
import { useLocation, useNavigate } from "react-router-dom";
import TableSkeleton from "../../../AllotedMaster/TableSkeleton";

bouncy.register();

const FrequencyBinsInnerReport = () => {
  const {
    frequencyBinsGVPInnerData,
    frequencyBinsGVPInnerDataLoading,
    frequencyBinsGVPInnerDataError,
    fetchFrequencyBinsGVPInnerReport,
  } = frequencyBinsGVPStore();
  const { state } = useLocation();
  // Helper function to format date with start time (00:00)
  const formatDateWithStartTime = (dateString) => {
    if (!dateString) return "";
    // Parse the date string (could be in various formats)
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
  };

  // Helper function to format selected date with current time
  const formatDateWithCurrentTime = (dateString) => {
    if (!dateString) return "";
    const selectedDate = new Date(dateString);
    if (isNaN(selectedDate.getTime())) return getCurrentDateTime();

    // Get current time
    const now = new Date();
    const currentHour = String(now.getHours()).padStart(2, "0");
    const currentMinute = String(now.getMinutes()).padStart(2, "0");

    // Use selected date with current time
    const year = selectedDate.getFullYear();
    const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
    const day = String(selectedDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T23:59`;
  };

  const fromDate = formatDateWithStartTime(state.date);
  const toDate = formatDateWithCurrentTime(state.date);

  const storedFilters = localStorage.getItem("frequencyBinsFilters");
  const parsedFilters = storedFilters ? JSON.parse(storedFilters) : null;

  useEffect(() => {
    if (fromDate && toDate) {
      fetchFrequencyBinsGVPInnerReport({
        FromDate: fromDate,
        ToDate: toDate,
      });
    }
  }, [fromDate, toDate]);



  // useEffect(() => {
  //     if (state?.date) {
  //         const fromDate = formatDateWithStartTime(state.date);
  //         const toDate = formatDateWithCurrentTime(state.date); // Selected date with current time

  //         fetchFrequencyBinsGVPInnerReport({
  //             FromDate: fromDate,
  //             ToDate: toDate,
  //         });
  //     }
  // }, [state?.date]);

  const isProd = isGHMC();
  const headerStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    borderRight: "none",
    padding: "10px",
    color: "#fff",
    backgroundColor: isProd ? "#0d5da5" : "#EC1117",
  };
  const cellStyles = {
    textAlign: "center",
    border: "1px solid #ddd",
    borderRight: "none",
    padding: "10px",
    whiteSpace: "normal",
  };

  const currentDate = getCurrentDateTime()
  const navigate = useNavigate();
  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="d-flex justify-content-end align-items-end gap-2 ">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  // Retrieve the current filters from localStorage
                  const storedFilters = localStorage.getItem("frequencyBinsFilters");
                  const parsedFilters = storedFilters ? JSON.parse(storedFilters) : null;

                  // Navigate back with filters
                  navigate("/frequency-bins-report", {
                    state: { filters: parsedFilters }, // pass filters as state
                  });
                }}
              >
                Back
              </button>


              <FrequencyBinsInnerExport
                data={frequencyBinsGVPInnerData}
                fromDate={formattedDate(state.date)}
                toDate={formattedDate(state.date)}
              />
            </div>

            <div className="page-header text-start">
              <div className="card">
                <div className="card-body">
                  <div className="top-header d-flex justify-content-center align-items-center">
                    <span>Detailed Shift Wise Data Report as on {formattedDate(state.date)} at ({formatDateTimeWithoutSec(currentDate)})</span>
                  </div>
                  <TableContainer
                    component={Paper}
                    sx={{
                      width: "100%",
                      border: "1px solid #ccc",
                      maxHeight: 700,
                    }}
                  >
                    {frequencyBinsGVPInnerDataLoading ? (
                      <TableSkeleton />
                    ) : (
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead
                        className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                        style={{ position: "sticky", top: 0 }}
                      >
                        <TableRow>
                          <TableCell rowSpan={2} sx={headerStyles}>
                            S.no
                          </TableCell>
                          <TableCell sx={{ ...headerStyles, minWidth: 80 }} rowSpan={2}>Corporation</TableCell>
                          <TableCell sx={{ ...headerStyles, minWidth: 80 }} rowSpan={2}>Shift</TableCell>
                          <TableCell colSpan={5} sx={headerStyles}>
                            GVPs
                          </TableCell>
                          <TableCell
                            colSpan={5}
                            sx={headerStyles}
                            style={{ textAlign: "center" }}
                          >
                            Sweeping Points
                          </TableCell>
                          <TableCell
                            colSpan={2}
                            sx={headerStyles}
                            style={{ textAlign: "center" }}
                          >
                            Others
                          </TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell sx={headerStyles}>
                            Points from Masters
                          </TableCell>
                          <TableCell sx={headerStyles}>
                            Points Cleared
                          </TableCell>
                          <TableCell sx={headerStyles}>Cleared %</TableCell>
                          <TableCell sx={headerStyles}>Not Cleared</TableCell>
                          <TableCell sx={headerStyles}>Not Cleared %</TableCell>
                          <TableCell sx={headerStyles}>
                            Points from Masters
                          </TableCell>
                          <TableCell sx={headerStyles}>
                            Points Cleared
                          </TableCell>
                          <TableCell sx={headerStyles}>Cleared %</TableCell>
                          <TableCell sx={headerStyles}>Not Cleared</TableCell>
                          <TableCell sx={headerStyles}>Not Cleared %</TableCell>
                          <TableCell sx={headerStyles}>Cleared</TableCell>
                          <TableCell sx={headerStyles}>Not Cleared</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {frequencyBinsGVPInnerData?.map((item, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              backgroundColor: isProd
                                ? index % 2 === 0
                                  ? "#8fc9ff"
                                  : "#aed8ff"
                                : index % 2 === 0
                                  ? "#F8CCCD"
                                  : "#ffeded",
                            }}
                          >
                            <TableCell sx={cellStyles}>{index + 1}</TableCell>
                            <TableCell sx={cellStyles}>
                              {item.corporationName}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.shiftName}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.gvpMasters}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.gvpCleared}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.gvpClearedPct}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.gvpNotCleared}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.gvpNotClearedPct}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.sweepMasters}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.sweepCleared}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.sweepClearedPct}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.sweepNotCleared}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.sweepNotClearedPct}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.othersCleared}
                            </TableCell>
                            <TableCell sx={cellStyles}>
                              {item.othersNotCleared}
                            </TableCell>
                          </TableRow>
                        ))}
                        {frequencyBinsGVPInnerData && frequencyBinsGVPInnerData.length > 0 && (() => {
                          const totalGvpMasters = frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.gvpMasters) || 0), 0);
                          const totalGvpCleared = frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.gvpCleared) || 0), 0);
                          const totalGvpNotCleared = frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.gvpNotCleared) || 0), 0);
                          const totalSweepMasters = frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.sweepMasters) || 0), 0);
                          const totalSweepCleared = frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.sweepCleared) || 0), 0);
                          const totalSweepNotCleared = frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.sweepNotCleared) || 0), 0);

                          const gvpClearedPct = totalGvpMasters > 0 ? ((totalGvpCleared / totalGvpMasters) * 100).toFixed(2) : 0;
                          const gvpNotClearedPct = totalGvpMasters > 0 ? ((totalGvpNotCleared / totalGvpMasters) * 100).toFixed(2) : 0;
                          const sweepClearedPct = totalSweepMasters > 0 ? ((totalSweepCleared / totalSweepMasters) * 100).toFixed(2) : 0;
                          const sweepNotClearedPct = totalSweepMasters > 0 ? ((totalSweepNotCleared / totalSweepMasters) * 100).toFixed(2) : 0;

                          return (
                            <TableRow
                              sx={{
                                backgroundColor: isProd ? "#fff" : "#fff",
                                //   color: "#fff",
                              }}
                            >
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }} colSpan={3}>
                                Total
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {totalGvpMasters}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {totalGvpCleared}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {gvpClearedPct}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {totalGvpNotCleared}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {gvpNotClearedPct}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {totalSweepMasters}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {totalSweepCleared}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {sweepClearedPct}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {totalSweepNotCleared}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {sweepNotClearedPct}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.othersCleared) || 0), 0)}
                              </TableCell>
                              <TableCell sx={{ ...cellStyles, fontWeight: "bold" }}>
                                {frequencyBinsGVPInnerData.reduce((sum, item) => sum + (parseFloat(item.othersNotCleared) || 0), 0)}
                              </TableCell>
                            </TableRow>
                          );
                        })()}
                      </TableBody>
                    </Table>
                    )}
                  </TableContainer>

                  {/* </Paper> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FrequencyBinsInnerReport;
